module.exports = __webpack_public_path__ + "img/page7img1.72d0b20e.png";